/**
 * @fileoverview Feature flags for brand-specific behavior (PLP, PDP, cart, checkout).
 *
 * **Dynamic pricing** (`DYNAMIC_PRICING_BRANDS`):
 * - PLP/PDP: tiles may SSR with image + name only; prices come from `POST /api/products/pricing`
 *   after the user signs in.
 * - Cart: `ShopifyCart` requires login (no guest cart), shows member subtotals from the same
 *   pricing API, and checkout uses `POST /api/draftorder` (Draft Order `invoiceUrl`) instead of
 *   the default Storefront checkout URL.
 * - To add a brand, append its **route slug** (same as `[vendor]` URL segment) to the array.
 *
 * @see docs/SHOPIFY_INTEGRATION.md
 */

/**
 * Vendors that use Nest-backed, session-scoped prices and Draft Order checkout.
 * Keep in sync with routing (e.g. `/gtr/...` → `'gtr'`).
 */
export const DYNAMIC_PRICING_BRANDS: string[] = ['gtr'];

/**
 * Whether this vendor slug uses the dynamic-pricing stack (auth-gated pricing + draft checkout).
 *
 * @param brand — Typically `useParams().vendor` or `'nestingale'` default.
 */
export function isDynamicPricingBrand(brand: string): boolean {
  return DYNAMIC_PRICING_BRANDS.includes(brand);
}
